/**
 * @description fetches the options for the facilities dropdown used by the filter form
 */

import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query'

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

/**
 * Fetches the facilities list (mock data)
 * @returns {Promise<{ label: string, value: string }[]>} - the list of eligibilities
 */
function fetchFacilities (context) {
  // eslint-disable-next-line no-unused-vars
  const [_, contractId] = context.queryKey;

  return fetch(`/contractAssignment/getFacilitiesBasedOnContractId?contractId=${ contractId }`)
    .then(decodeJson)
    .catch(({ body }) => {
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve facility list. Reload the page and try again');
    });
}

function processFacilities (response) {
  return response.map((facility) => ({
    label: `${ facility.name } (${ facility.facilityCode })`,
    value: facility.id
  }));
}

const useFacilityOptions = () => {
  const { contractId } = useParams();

  const { data, isError, isLoading } = useQuery({
    queryKey: ['useFacilityFilter', contractId],
    queryFn: fetchFacilities,
    refetchOnWindowFocus: false,
    select: processFacilities,
    staleTime: Infinity
  });

  return {
    data,
    isError,
    isLoading
  };
};

export default useFacilityOptions;
